<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="10">
          <v-row>
            <v-col cols="4">
              <v-select
                :items="exams"
                v-model="exam"
                label="Chọn kỳ kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
                @change="examSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="subjects"
                v-model="subject"
                label="Chọn môn kiểm tra"
                item-value="id"
                item-text="name"
                return-object
                outlined
                dense
                hide-details
                @change="subjectSelected"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="filteredRoomSubjects"
                v-model="roomSubject"
                label="Chọn số túi"
                item-value="id"
                item-text="roomCode"
                return-object
                outlined
                dense
                clearable
                class="pr-6"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="2">
          <v-btn
            :disabled="!exam || !subject"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
            v-if="$auth.role.type === 'manager'"
          >
            Xác nhận
          </v-btn>
          <v-btn
            v-else
            :disabled="!exam || !roomSubject || !subject"
            height="40"
            width="100%"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Xác nhận
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: '',
      roomSubject: '',
      subject: '',
      exams: [],
      subjects: [],
      roomSubjects: [],
      filteredRoomSubjects: [],
      teacher: {}
    }
  },
  async mounted() {
    await this.getExams()
  },
  methods: {
    ...mapActions('subjectExam', ['fetchSubjects']),
    ...mapActions('roomSubject', ['fetchRoomSubjects']),
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('teacherExam', ['fetchTeacherExams']),
    onFilterChanged() {
      const params = {
        exam: this.exam.id,
        roomCode: this.roomSubject ? this.roomSubject.roomCode : '',
        subject: this.subject ? this.subject.id : ''
      }
      const fileName = `${this.exam.name}_${this.subject.name}${
        this.roomSubject ? `_${this.roomSubject.roomCode}` : ``
      }`
      this.$emit('onFilterChanged', params, this.roomSubject, fileName, this.subject, this.exam)
    },
    async getExams() {
      this.$loading.active = true
      this.exams = await this.fetchExams({ status: 'active' })
      this.$loading.active = false
    },

    async getRoomSubjects(query) {
      if (this.$auth.role.type === 'teacher') {
        query.teacher = this.$auth.user.teacher
      }
      const results = await this.fetchRoomSubjects(query)
      this.filteredRoomSubjects = results.filter(subject => subject.roomCode)
    },
    async getSubjects(query) {
      this.subjects = await this.fetchSubjects(query)
    },
    async examSelected() {
      this.$loading.active = true
      await this.getSubjects({ exam: this.exam ? this.exam.id : '' })

      this.$loading.active = false
    },

    async subjectSelected() {
      this.$loading.active = true
      await this.getRoomSubjects({ subject: this.subject.id })
      if (this.$auth.role.type === 'teacher' && this.teacher && this.teacher.rooms) {
        this.filteredRoomSubjects = this.filteredRoomSubjects.filter(room =>
          this.teacher.rooms.some(teacherRoom => teacherRoom.id === room.room.id)
        )
      }
      this.$loading.active = false
    }
  }
}
</script>
